export default __webpack_public_path__ + "static/media/Frontal 40 ausmessen.9cbe33fc.jpg";